import { Injectable, EventEmitter } from '@angular/core';
import {Post,Comment, View, Like, User } from '../../_models/index';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  data: Post[] = [];
  currentsectionsSubjects:number ;

  setsectionsSubjects(id:number)
  {
    this.currentsectionsSubjects =id;
    this.ChangeNotefier.emit( this.getBySectionsSubjectsId(id));
  }
  constructor() {
   
  }
  public ChangeNotefier  = new EventEmitter();

  getall(): Post[] {

    return this.data;
  }
  getBySectionsSubjectsId(id): Post[] {

    return this.data.filter(e=>e.sectionsSubjectsId == id );
  }

  getById(id :number): Post {

    return this.data.find(f=>f.id ==id);
  }

  count() :number{
    if(this.data)
    return this.data.length;
    else
    return 0;
  }
  
  insertPost (item :Post){
    if(this.currentsectionsSubjects) item.sectionsSubjectsId = this.currentsectionsSubjects;
    this.data.push(item);
    
    this.ChangeNotefier.emit(this.getBySectionsSubjectsId(this.currentsectionsSubjects));
  }

  removePost(item : Post)
  {
    let i =  this.data.findIndex(f=>f.id ==item.id);
    if(i>-1)
    {
      this.data.splice(i,1);
      this.ChangeNotefier.emit(this.getBySectionsSubjectsId(this.currentsectionsSubjects));
    }
  }
  
  updatePost(id :number ,item:Post){
    let i= this.data.findIndex(f=>f.id ==id);
    if(i>-1)
    {
    this.data[i]={...item}
    this.ChangeNotefier.emit(this.getBySectionsSubjectsId(this.currentsectionsSubjects));
    }
  }

}
@Injectable({
  providedIn: 'root'
})
export class CommentService {

  data: Comment[] = [];
  constructor() {
   
  }
  public ChangeNotefier  = new EventEmitter();

  getall(): Comment[] {

    return this.data;
  }
  getById(id :number): Comment {

    return this.data.find(f=>f.id ==id);
  }

  getByPostId(id :number): Comment []{

    const list   = [];
    this.data.forEach(item=>{
        if(item.postId ==id)
        {
          list.push(item);
        }

    });

    return list;
  } 

  countForPost(id) :number{
    const list  = [];
    this.data.forEach(item=>{
        if(item.postId ==id)
        {
          list.push(item);
        }

    });
    if(list)
    {
      return list.length;
    }
    else
    {
     return 0;
    }
  }
  count() :number{
    if(this.data)
    return this.data.length;
    else
    return 0;
  }
  
  removeForPost(id) {
     let el = this.data.length;
     for(let i =0;i<el;)
     {
       if(this.data[i])
       {
        if(this.data[i].postId ==id)
        {
         this.data.splice(i,1);
         let el = this.data.length;
      
         if(el == 0)
         {
           break;
         } 
 
         i=0;
        }
        else{
          i++;
        }
       }
       else
       {
         break;
       }
       

     }
  }
  insertComment (item :Comment){
    this.data.push(item);
    this.ChangeNotefier.emit(this.data);
  }

  removeComment(item : Comment)
  {
    let i =  this.data.findIndex(f=>f.id ==item.id);
    if(i>-1)
    {
      this.data.splice(i,1);
      this.ChangeNotefier.emit(this.data);
    }
  }
  
  updateComment(id :number ,item:Comment){
    let i= this.data.findIndex(f=>f.id ==id);
    if(i>-1)
    {
    this.data[i]={... item};
    this.ChangeNotefier.emit(this.data);
    }
  }



}
@Injectable({
  providedIn: 'root'
})
export class ViewService {

  data: View[] = [];
  constructor() {
   
  }
  public ChangeNotefier  = new EventEmitter();

  getall(): View[] {

    return this.data;
  }
  getById(id :number): View {

    return this.data.find(f=>f.id ==id);
  }

  getByPostId(id :number): View []{

    const list  = [];
    this.data.forEach(item=>{
        if(item.postId ==id)
        {
          list.push(item);
        }

    });

    return list;
  } 

  countForPost(id) :number{
    const list  = [];
    this.data.forEach(item=>{
        if(item.postId ==id)
        {
          list.push(item);
        }

    });
    if(list)
    {
      return list.length;
    }
    else
    {
     return 0;
    }
  }
  count() :number{
    if(this.data)
    return this.data.length;
    else
    return 0;
  }
  
  removeForPost(id) {
    let el = this.data.length;
    for(let i =0;i<el;)
    {
      if(this.data[i])
      {
       if(this.data[i].postId ==id)
       {
        this.data.splice(i,1);
        let el = this.data.length;
     
        if(el == 0)
        {
          break;
        } 

        i=0;
       }
       else{
         i++;
       }
      }
      else
      {
        break;
      }
      

    }
 }
  insertView (item :View){
     let i = this.data.findIndex(f=>f.user.id == item.user.id && f.postId ==item.postId);
     if(i==-1)
     {
      this.data.push(item);
      this.ChangeNotefier.emit(this.data);
     }

  }

  removeView(item : View)
  {
    let i =  this.data.findIndex(f=>f.id ==item.id);
    if(i>-1)
    {
      this.data.splice(i,1);
      this.ChangeNotefier.emit(this.data);
    }
  }
  
  updateView(id :number ,item:View){
    let i= this.data.findIndex(f=>f.id ==id);
    if(i>-1)
    {
    this.data[i]= JSON.parse(JSON.stringify(item));
    this.ChangeNotefier.emit(this.data);
    }
  }



}
@Injectable({
  providedIn: 'root'
})
export class LikeService {

  data: Like[] = [];
  constructor() {
   
  }
  public ChangeNotefier  = new EventEmitter();

  removeForPost(id) {
    let el = this.data.length;
    for(let i =0;i<el;)
    {
      if(this.data[i])
      {
       if(this.data[i].postId ==id)
       {
        this.data.splice(i,1);
        let el = this.data.length;
     
        if(el == 0)
        {
          break;
        } 

        i=0;
       }
       else{
         i++;
       }
      }
      else
      {
        break;
      }
      

    }
 }
  getall(): Like[] {

    return this.data;
  }
  getById(id :number): Like {

    return this.data.find(f=>f.id ==id);
  }

  getByPostId(id :number): Like []{

    const list  = [];
    this.data.forEach(item=>{
        if(item.postId ==id)
        {
          list.push(item);
        }

    });

    return list;
  } 

  countForPost(id) :number{
    const list  = [];
    this.data.forEach(item=>{
        if(item.postId ==id && item.islike)
        {
          list.push(item);
        }

    });
    if(list)
    {
      return list.length;
    }
    else
    {
     return 0;
    }
  }
  count() :number{
    if(this.data)
    return this.data.length;
    else
    return 0;
  }
  
  insertLike (item :Like){
    let  i = this.data.findIndex(f  => f.user.id == item.user.id && f.postId == item.postId );
    if(i==-1)
    {
      this.data.push(item);
      this.ChangeNotefier.emit(this.data);
    }
    else
    {
      let li = this.data[i];
      li.islike =true;
      this.updateLike(li.id,li);
    }
 
  }

  removeLike(item : Like)
  {
    let i =  this.data.findIndex(f=>f.id ==item.id);
    if(i>-1)
    {
      this.data.splice(i,1);
      this.ChangeNotefier.emit(this.data);
    }
  }
  
  updateLike(id :number ,item:Like){
    let i= this.data.findIndex(f=>f.id ==id);
    if(i>-1)
    {
    this.data[i]= {...item}
    
    this.ChangeNotefier.emit(this.data);
    }
  }

  isLike(user :User,post :Post) :boolean{

    let  i = this.data.findIndex(f  => f.user.id == user.id && f.postId == post.id && f.islike ==true);
    return i!=-1;
  }

  unLike(user :User,post :Post) {

    let  i = this.data.findIndex(f  => f.user.id == user.id && f.postId == post.id);
    if(i!=-1)
    {
      let li = this.data[i];
      li.islike =false;
      this.updateLike(li.id,li);
    }
  }

}



